(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmReferralSourceTypeDialogController', CrmReferralSourceTypeDialogController);

    CrmReferralSourceTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CrmReferralSourceType', 'Corporation'];

    function CrmReferralSourceTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CrmReferralSourceType, Corporation) {
        var vm = this;

        vm.crmReferralSourceType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.crmReferralSourceType.id !== null) {
                CrmReferralSourceType.update(vm.crmReferralSourceType, onSaveSuccess, onSaveError);
            } else {
                CrmReferralSourceType.save(vm.crmReferralSourceType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:crmReferralSourceTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
